import styled from 'styled-components';

export const Container = styled.div`
  .active-services-bg {
    background-color: ${(props) => props.theme.$bg_gray};
  }

  .portals-scroll {
    max-height: 620px;
    overflow-y: scroll;
    overflow-x: hidden;
    background-color: ${(props) => props.theme.$bg_gray};
    border-radius: 16px;
    padding: 8px;

    > .row {
      margin-left: 0;
      margin-right: 0;
    }

    &::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 8px;

      &-thumb {
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.5);
        -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
      }
    }

    @media only screen and (max-width: 768px) {
      max-height: 60vh;
    }
  }

  .position-one {
    position: relative;
    z-index: 1;
    margin-top: 100px;
  }

  .bg-img {
    margin: -100px 0 100px 0;
    padding: 25px 0 25px 0;
    background-color: ${(props) => props.theme.$primary_green};
    clip-path: polygon(0 15%, 70% 0, 100% 0, 100% 100%, 0 100%);

    @media only screen and (max-width: 768px) {
      margin: 100px 0 100px 0;
      clip-path: polygon(0 0%, 70% 0, 100% 0, 100% 100%, 0 100%);
    }
  }

  .session-one .card {
    border-radius: 36px;
    background: rgba(255, 255, 255, 0.12);
    display: flex;
  }

  .session-one .card p {
    color: #fff;
    font-size: 20px;
  }

  .session-one .card img {
    width: 45px;
  }

  .icon-text {
    display: flex;
    align-items: center;
  }

  .icon {
    margin-right: 8px;
  }

  .icon-2 {
    color: ${(props) => props.theme.$dark};
  }

  button {
    border-radius: 40px;
    font-weight: bold;
  }
  .button-green {
    border-radius: 30px;
    background-color: ${(props) => props.theme.$primary_green};
  }

  h1,
  h4,
  h2 {
    color: ${(props) => props.theme.$dark};
  }

  .margin {
    margin-top: 130px;
  }

  .preco-antigo {
    color: ${(props) => props.theme.$dark};
    font-size: 39.379px;
    text-decoration-line: strikethrough;
  }

  span .preco-novo {
    color: ${(props) => props.theme.$dark};
    font-size: 47.809px;
    font-weight: 700;
  }

  strong {
    color: ${(props) => props.theme.$dark};
  }

  .container-video {
    border: 5px solid #f0f1f2;
    border-radius: 20px;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.2);
    background: #f0f1f2;

    @media only screen and (max-width: 768px) {
      border: 0;
      box-shadow: none;
      background: none;
    }
  }

  .bg-dark {
    background-color: ${(props) => props.theme.$dark} !important;
    padding: 55px;
  }

  .text {
    font-size: 26px;
  }
  .text-img {
    font-size: 18px;
    color: ${(props) => props.theme.$dark};
  }

  .card {
    background-color: transparent;
    color: ${(props) => props.theme.$white};
    border: 1px solid ${(props) => props.theme.$white};
    text-align: center;
    display: flex;
    height: 100%;
    flex-direction: column;

    &.card-price {
      height: auto;
      border: 2px solid ${(props) => props.theme.$primary_green};
      border-radius: 16px;

      .sale-price-tag {
        background-color: ${(props) => props.theme.$primary_green};
        border-radius: 10px 10px 0 0;
      }
    }
  }

  .img-person {
    margin-top: -91px;
  }

  .btn-sale-page {
    background-color: ${(props) => props.theme.$primary_green};
    border-color: ${(props) => props.theme.$primary_green};
    color: ${(props) => props.theme.$white};
  }
`;
